import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-mask"
};
const _hoisted_2 = {
  class: "schedule-dialog"
};
const _hoisted_3 = {
  class: "actions"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_time_picker = _resolveComponent("el-time-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", null, _toDisplayString($props.schedule ? "编辑日程" : "新增日程"), 1), _createElementVNode("label", null, [_cache[8] || (_cache[8] = _createTextVNode("添加主题", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.title,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.title = $event),
    placeholder: "请填写"
  }, null, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[9] || (_cache[9] = _createTextVNode("日程日期", -1)), _createVNode(_component_el_date_picker, {
    modelValue: $data.form.date,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.date = $event),
    type: "date",
    "value-format": "YYYY-MM-DD",
    format: "YYYY-MM-DD",
    placeholder: "请选择日期"
  }, null, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[10] || (_cache[10] = _createTextVNode("时间段", -1)), _createVNode(_component_el_time_picker, {
    modelValue: $data.timeRange,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.timeRange = $event),
    "is-range": "",
    "range-separator": "至",
    "start-placeholder": "开始时间",
    "end-placeholder": "结束时间",
    format: "HH:mm",
    "value-format": "HH:mm"
  }, null, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[11] || (_cache[11] = _createTextVNode("日程安排", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.scheduleContent,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.scheduleContent = $event),
    type: "textarea",
    rows: 4
  }, null, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[12] || (_cache[12] = _createTextVNode("备注", -1)), _createVNode(_component_el_input, {
    modelValue: $data.form.remark,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.remark = $event),
    type: "textarea",
    rows: 4
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [$props.schedule ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "danger",
    disabled: $data.saving,
    onClick: _cache[5] || (_cache[5] = (...args) => $options.remove && $options.remove(...args))
  }, "删除", 8, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("button", {
    class: "primary",
    disabled: $data.saving,
    onClick: _cache[6] || (_cache[6] = (...args) => $options.save && $options.save(...args))
  }, "确认", 8, _hoisted_5), _createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.$emit('close'))
  }, "取消")])])]);
}